export default __webpack_public_path__ + "static/media/ptFlag.8251fd68.svg";